/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_DEFAULTS_HELP = {
  screenId: 'settings-defaults',
  label: 'Valores predeterminados',
  navPath: 'Configuración → Valores predeterminados',
  keywords: ['predeterminado', 'pos default', 'caja default', 'asistente ia', 'concepto arca'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Preferencias personales por usuario: POS, caja, concepto AFIP y visibilidad del asistente de IA.',
  sidebarItems: [{
    id: 'defaults',
    screenId: 'settings-defaults',
    label: 'Configuración por usuario',
    description: 'Valores que el sistema recuerda al facturar o usar el asistente.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Definís tus preferencias personales. No cambian la configuración de la empresa: solo afectan tu usuario al abrir pantallas de ventas, cobros o el asistente de IA.',
        },
        {
          title: 'Paso 1 — Abrir la ventana',
          steps: [
            'Entrá a Configuración → Valores predeterminados.',
            'Se abre una ventana con tus opciones actuales.',
          ],
        },
        {
          title: 'Paso 2 — Elegir valores',
          fields: [
            { label: 'Punto de venta', description: 'POS que se preselecciona al facturar (opcional). Solo aparecen los que tenés habilitados.' },
            { label: 'Caja', description: 'Caja predeterminada para movimientos (opcional).' },
            { label: 'Concepto ARCA', description: 'Productos, Servicios o Productos y Servicios para comprobantes electrónicos (opcional).' },
            { label: 'Mostrar asistente de IA', description: 'Casilla marcada = ves el asistente; desmarcada = oculto en tu sesión.' },
          ],
          paragraphs: [
            'Podés dejar vacíos POS, caja y concepto si no querés un valor fijo.',
            'El asistente de IA siempre se guarda (activo o no).',
          ],
        },
        {
          title: 'Paso 3 — Guardar',
          paragraphs: [
            'Tocá «Guardar». La ventana se cierra y los cambios quedan aplicados a tu usuario.',
          ],
        },
      ],
    },
  }],
}
